<template>
  <div class="d-flex btn-status w-100 justify-content-end align-items-center">
    <!-- Batch Status = ALLOC - START -->
    <template v-if="batch.btnAction.alloc">
      <batch-control-button
        btnClass="info"
        textClass="white"
        iconName="format_list_numbered"
        @click="onAlloc($event, batch)"
        @focus="e => e.target.blur()"
      >
        自動割当
      </batch-control-button>
    </template>
    <!-- Batch Status = ALLOC - END -->
    <!-- Batch Status = START - START -->
    <template v-if="batch.btnAction.cancelStart">
      <batch-control-button
        class="cancel-start-button"
        btnClass="white"
        textClass="info"
        borderClass="info"
        iconName=""
        @click="onStart($event, batch)"
        @focus="e => e.target.blur()"
      >
        実行取消
      </batch-control-button>
    </template>
    <template v-if="batch.btnAction.start">
      <batch-control-button
        class="px-4"
        btnClass="info"
        textClass="white"
        borderClass="info"
        iconName="play_arrow"
        @click="onStart($event, batch)"
        @focus="e => e.target.blur()"
      >
        実行
      </batch-control-button>
    </template>
    <!-- Batch Status = START - END -->
    <!-- Batch Status = TEMPORARY HOLDING - START -->
    <template v-if="batch.btnAction.temporary_unHolding && showTemporaryHolding">
      <batch-control-button
        class="unhold-button"
        btnClass="info"
        textClass="white"
        borderClass="info"
        iconName="play_arrow"
        @click="onTemporaryHolding($event, batch)"
        @focus="e => e.target.blur()"
      >
        保留解除
      </batch-control-button>
    </template>
    <template v-if="batch.btnAction.temporary_holding && showTemporaryHolding">
      <batch-control-button
        btnClass="white"
        textClass="info"
        borderClass="info"
        iconName="pause"
        @click="onTemporaryHolding($event, batch)"
        @focus="e => e.target.blur()"
      >
        一時保留
      </batch-control-button>
    </template>
    <!-- Batch Status = TEMPORARY HOLDING - END -->
    <!-- Batch Status = TRACK - START -->
    <template v-if="batch.btnAction.track">
      <batch-control-button
        class="p-3"
        :btnClass="batch.manualCsvOutFlag > 0 ? 'white' : 'info'"
        :textClass="batch.manualCsvOutFlag > 0 ? 'info' : 'white'"
        borderClass="info"
        iconName="download"
        @click="onClickDownload($event, batch)"
        @focus="e => e.target.blur()"
      >
        実績DL
      </batch-control-button>
    </template>
    <!-- Batch Status = TRACK - END -->
    <!-- Batch Status = FINISH - START -->
    <template v-if="batch.btnAction.finish">
      <batch-control-button
        class="p-4"
        :btnClass="(batch.status && batch.status === 4) || (batch.btnAction.color) ? 'info' : 'white'"
        :textClass="(batch.status && batch.status === 4) || (batch.btnAction.color) ? 'white' : 'info'"
        borderClass="info"
        @click="onFinish($event, batch)"
        @focus="e => e.target.blur()"
      >
        締め
      </batch-control-button>
    </template>
    <!-- Batch Status = FINISH - END -->
  </div>
</template>

<script>
import BatchControlButton from './BatchControlButton.vue'
export default {
  data() {
    return {
      internalBatch: {}
    }
  },
  components: {
    BatchControlButton
  },
  props: ['batch', 'showTemporaryHolding'],
  watch: {
    batch: {
      handler: function (newValue, oldValue) {
        this.internalBatch = newValue
        this.$nextTick()
      },
      deep: true
    }
  },
  methods: {
    onAlloc(e, batch) {
      e.preventDefault()
      this.$emit('on-alloc', batch)
    },
    onStart(e, batch) {
      e.preventDefault()
      this.$emit('on-start', batch)
    },
    onTemporaryHolding(e, batch) {
      e.preventDefault()
      this.$emit('on-temporary-holding', batch)
    },
    onClickDownload(e, batch) {
      e.preventDefault()
      this.$emit('on-download', batch)
    },
    onFinish(e, batch) {
      e.preventDefault()
      this.$emit('on-finish', batch)
    }
  }
}
</script>

<style lang="scss" scoped>
  .btn-batch {
    margin-right: 0.25rem;
    &:first-of-type {
      margin-left: 20px;
      @include media-breakpoint-default() {
        margin-left: 10px;
      }
    }
    &:last-of-type {
      margin-right: 0;
    }
  }
  .cancel-start-button, .unhold-button {
    margin-right: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom-components/BuildBatchActionButtons.vue